import * as S from './styles';

import { MediaMatch } from '../../../MediaMatch';
import { Skeleton } from '../../../Skeleton';
import { Typography } from '../../../Typography';

import { formatGtm } from '../../../../../utils/formatGtm';

import { CardSecondaryProps } from './types';

export const CardSecondary = ({
	secondaryCardTitle = 'Até 18 caracteres',
	secondaryCardLinkUrlOne = 'https://www.portoseguro.com.br/',
	secondaryCardExternalLinkOne = true,
	secondaryCardDescriptionOne = 'Até 20 caracteres',
	secondaryCardImageOne = 'https://via.placeholder.com/236x102',
	secondaryCardDescriptionTwo = 'Até 20 caracteres',
	secondaryCardImageTwo = 'https://via.placeholder.com/236x102',
	secondaryCardLinkUrlTwo = 'https://www.portoseguro.com.br/',
	mode = 'light',
	secondaryCardExternalLinkTwo = true,
	isLoading = false,
	headingCardSecondary,
	headingCardSecondaryProduct1,
	headingCardSecondaryProduct2,
	gtmName,
}: CardSecondaryProps) => {
	function handleClick(url: string, target: boolean) {
		window.open(url, target ? '_blank' : '_self');
	}
	return (
		<>
			{isLoading ? (
				<>
					<MediaMatch lessThan="desktop">
						<S.CardProductContainer data-id="card-product" mode={mode}>
							<S.TitleCard tabIndex={0}>
								<Skeleton width={100} height={2.6} />
							</S.TitleCard>
							<S.ItemSecondaryContainer>
								<S.ItemSecondary>
									<S.TitleCard>
										<Skeleton width={100} height={2.6} />
									</S.TitleCard>
									<Skeleton width={100} height={10.1} borderRadius={1.6} />
								</S.ItemSecondary>
								<S.ItemSecondary>
									<S.TitleCard>
										<Skeleton width={100} height={2.6} />
									</S.TitleCard>
									<Skeleton width={100} height={10.1} borderRadius={1.6} />
								</S.ItemSecondary>
							</S.ItemSecondaryContainer>
						</S.CardProductContainer>
					</MediaMatch>
					<MediaMatch greaterThan="desktop">
						<S.CardProductContainer data-id="card-product" mode={mode}>
							<S.TitleCard tabIndex={0}>
								<Skeleton width={100} height={2.4} />
							</S.TitleCard>
							<div style={{ height: '122px' }}>
								<div style={{ height: '22px', marginBottom: '4px' }}>
									<Skeleton width={100} height={2.4} />
								</div>
								<Skeleton width={100} height={9} borderRadius={1.6} />
							</div>
							<div style={{ height: '122px' }}>
								<div style={{ height: '22px', marginBottom: '4px' }}>
									<Skeleton width={100} height={2.4} />
								</div>
								<Skeleton width={100} height={9} borderRadius={1.6} />
							</div>
						</S.CardProductContainer>
					</MediaMatch>
				</>
			) : (
				<S.CardProductContainer
					role="card-secondary"
					data-id="card-product"
					mode={mode}
				>
					<S.TitleCard tabIndex={0}>
						<Typography
							as={headingCardSecondary}
							color="portoSeguros100"
							type="Title6"
							weight="medium"
						>
							{secondaryCardTitle}
						</Typography>
					</S.TitleCard>
					<S.ItemSecondaryContainer>
						<S.Link
							href={secondaryCardLinkUrlOne}
							target={secondaryCardExternalLinkOne ? '_blank' : '_self'}
							tabIndex={0}
							role="card-secondary-link-url-one"
							rel="noreferrer"
							data-gtm-type="click"
							data-gtm-clicktype="card"
							data-gtm-name={formatGtm(gtmName)}
							data-gtm-subname={`${formatGtm(secondaryCardTitle)}:${formatGtm(
								secondaryCardDescriptionOne
							)}`}
							mode={mode}
							onClick={() =>
								handleClick(
									secondaryCardLinkUrlOne!,
									secondaryCardExternalLinkOne!
								)
							}
						>
							<S.ItemSecondary>
								<Typography
									as={headingCardSecondaryProduct1}
									type="Body1"
									weight="regular"
								>
									{secondaryCardDescriptionOne}
								</Typography>
								<S.Image
									loading="lazy"
									src={secondaryCardImageOne}
									alt={secondaryCardDescriptionOne}
									width={256}
									height={96}
								/>
							</S.ItemSecondary>
						</S.Link>
						<S.Link
							href={secondaryCardLinkUrlTwo}
							target={secondaryCardExternalLinkTwo ? '_blank' : '_self'}
							tabIndex={0}
							rel="noreferrer"
							role="card-secondary-link-url-two"
							data-gtm-type="click"
							data-gtm-clicktype="card"
							data-gtm-name={formatGtm(gtmName)}
							data-gtm-subname={`${formatGtm(secondaryCardTitle)}:${formatGtm(
								secondaryCardDescriptionTwo
							)}`}
							mode={mode}
							onClick={() =>
								handleClick(
									secondaryCardLinkUrlTwo!,
									secondaryCardExternalLinkTwo!
								)
							}
						>
							<S.ItemSecondary>
								<Typography
									as={headingCardSecondaryProduct2}
									type="Body1"
									weight="regular"
								>
									{secondaryCardDescriptionTwo}
								</Typography>
								<S.Image
									loading="lazy"
									src={secondaryCardImageTwo}
									alt={secondaryCardDescriptionTwo}
									width={256}
									height={96}
								/>
							</S.ItemSecondary>
						</S.Link>
					</S.ItemSecondaryContainer>
				</S.CardProductContainer>
			)}
		</>
	);
};
